module.exports = __webpack_public_path__ + "static/media/starshipit2.265cd60c.jpg";